<template>
    <v-sheet>
        <v-tabs v-model="levelTwoTab" color="primary" density="compact">
            <v-tab value="Parts">Parts</v-tab>
            <v-tab value="Operations">Operations</v-tab>
        </v-tabs>

        <v-divider></v-divider>

        <v-window v-model="levelTwoTab">
            <v-window-item value="Parts" class="py-3">
                <PartsWindow />
            </v-window-item>

            <v-window-item value="Operations" class="py-3">
                <OperationsWindow />
            </v-window-item>
        </v-window>
    </v-sheet>
</template>

<script>
    import PartsWindow from "./Engineering/PartsWindow.vue";
    import OperationsWindow from "./Engineering/OperationsWindow.vue";
    import { useJobEntryStore } from '../../../../stores/ProjectManagement/JobEntry';
    import { mapWritableState } from 'pinia';

    export default {
        name: "Engineering",
        components: {
            PartsWindow,
            OperationsWindow,
        },
        computed: {
            ...mapWritableState(useJobEntryStore, {
                levelTwoTab: "levelTwoTab",
            }),
        },
        watch: {},
        methods: {}
    }
</script>

<style scoped>

</style>
